// extracted by mini-css-extract-plugin
export default {"MessagesList":"styles_MessagesList__f77hU"};